import { render, staticRenderFns } from "./EmailTemplateCreateModal.vue?vue&type=template&id=7133cf3a&"
import script from "./EmailTemplateCreateModal.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplateCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports